import { Button } from "../ui/button";
import { MdMenu } from "react-icons/md";
import { Sheet, SheetContent, SheetTrigger } from "../ui/sheet";

import { BiFoodMenu } from "react-icons/bi";
import { BadgeInfo, Home } from "lucide-react";
import { BiMessageSquare } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

export function MenuSheet({
  side = "left",
  goTo,
  icon: Icon = MdMenu,
  pageName = "menu",
}) {
  const navigate = useNavigate();
  return (
    <Sheet className="z-[100000000] lg:hidden">
      <SheetTrigger asChild className="z-[100000000] lg:hidden">
        <Icon className="text-mariposa text-[32px] cursor-pointer" />
      </SheetTrigger>
      <SheetContent
        side={side}
        className=" flex flex-col sm:w-[300px]  h-full z-[100000000000] items-start"
      >
        <div className="flex flex-col gap-4 py-4 w-full">
          <div className="flex flex-col gap-2 gap-4">
            <div
              className="cursor-pointer flex hover:bg-mariposa hover:text-white text-[20px] w-full gap-4 items-center px-4 py-2 rounded-md"
              onClick={(e) => goTo("inicio")}
            >
              <Home></Home>
              <span>Inicio</span>
            </div>
            <div
              className=" cursor-pointer flex hover:bg-mariposa hover:text-white text-[20px] w-full gap-4 items-center px-4 py-2 rounded-md"
              onClick={(e) => goTo("especiales")}
            >
              <BiFoodMenu></BiFoodMenu>
              <span>Especiales</span>
            </div>
            <div
              className="cursor-pointer flex hover:bg-mariposa hover:text-white text-[20px] w-full gap-4 items-center px-4 py-2 rounded-md"
              onClick={(e) => goTo("about")}
            >
              <BadgeInfo></BadgeInfo>
              <span>Sobre Nosotros</span>
            </div>
            <div
              className="cursor-pointer flex hover:bg-mariposa hover:text-white text-[20px] w-full gap-4 items-center px-4 py-2 rounded-md"
              onClick={(e) => goTo("contact")}
            >
              <BiMessageSquare></BiMessageSquare>
              <span>Contactanos</span>
            </div>
            {pageName !== "menu" && (
              <Button
                className="flex w-[100px] bg-mariposa text-white px-6 py-4 text-[14px] font-bold font-Lato "
                onClick={() => navigate("/menu")}
              >
                {" "}
                Ver menú{" "}
              </Button>
            )}
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
